import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram, FaEnvelope, FaHeart } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-100 pt-8 pb-4 text-slate-600 font-sans">
      <div className="container-responsive px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">

          {/* Brand Section */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-slate-800 flex items-center gap-2">
              <span className="text-green-700">Elcid</span> Research
            </h3>
            <p className="text-sm leading-relaxed text-slate-500 max-w-xs">
              Elcid Research is a global market research company providing high quality data collection services. We connect with over 8 million respondents across 35 countries to deliver accurate and timely insights.
            </p>
            <div className="flex gap-3">
              <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-8 h-8 rounded-full bg-slate-50 text-slate-400 flex items-center justify-center hover:bg-green-50 hover:text-green-600 transition-all duration-300 transform hover:scale-110">
                <FaFacebook size={18} />
              </a>
              <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="w-8 h-8 rounded-full bg-slate-50 text-slate-400 flex items-center justify-center hover:bg-green-50 hover:text-green-600 transition-all duration-300 transform hover:scale-110">
                <FaTwitter size={18} />
              </a>
              <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="w-8 h-8 rounded-full bg-slate-50 text-slate-400 flex items-center justify-center hover:bg-green-50 hover:text-green-600 transition-all duration-300 transform hover:scale-110">
                <FaLinkedin size={18} />
              </a>
              <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-8 h-8 rounded-full bg-slate-50 text-slate-400 flex items-center justify-center hover:bg-green-50 hover:text-green-600 transition-all duration-300 transform hover:scale-110">
                <FaInstagram size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-bold text-slate-800 uppercase tracking-wider mb-3">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-green-600 hover:pl-2 transition-all duration-300 block">Home</Link></li>
              <li><Link to="/surveys" className="hover:text-green-600 hover:pl-2 transition-all duration-300 block">Available Surveys</Link></li>
              <li><Link to="/rewards" className="hover:text-green-600 hover:pl-2 transition-all duration-300 block">Rewards Program</Link></li>
              <li><Link to="/dashboard" className="hover:text-green-600 hover:pl-2 transition-all duration-300 block">User Dashboard</Link></li>
              <li><a href="#" className="hover:text-green-600 hover:pl-2 transition-all duration-300 block">How It Works</a></li>
              <li><a href="#" className="hover:text-green-600 hover:pl-2 transition-all duration-300 block">FAQ</a></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-sm font-bold text-slate-800 uppercase tracking-wider mb-3">Support & Legal</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="hover:text-green-600 hover:pl-2 transition-all duration-300 block">Help Center</a></li>
              <li><a href="#" className="hover:text-green-600 hover:pl-2 transition-all duration-300 block">Contact Support</a></li>
              <li><a href="#" className="hover:text-green-600 hover:pl-2 transition-all duration-300 block">Privacy Policy</a></li>
              <li><a href="#" className="hover:text-green-600 hover:pl-2 transition-all duration-300 block">Terms of Service</a></li>
              <li><a href="#" className="hover:text-green-600 hover:pl-2 transition-all duration-300 block">Cookie Policy</a></li>
              <li><a href="#" className="hover:text-green-600 hover:pl-2 transition-all duration-300 block">Panelist Agreement</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-bold text-slate-800 uppercase tracking-wider mb-3">Get in Touch</h3>
            <div className="space-y-3 text-sm">
              <div className="flex items-start gap-3 group">
                <div className="w-8 h-8 rounded-lg bg-green-50 text-green-600 flex items-center justify-center shrink-0 group-hover:bg-green-100 transition-colors duration-300">
                  <FaEnvelope size={14} />
                </div>
                <div>
                  <span className="block text-xs font-semibold text-slate-400 uppercase mb-0.5">Contact Us</span>
                  <a href="mailto:info@elcidresearch.com" className="font-medium text-slate-700 hover:text-green-600 transition-colors">info@elcidresearch.com</a>
                </div>
              </div>
            </div>
            <div className="mt-4 pt-4 border-t border-gray-100">
              <p className="text-xs text-slate-500 flex items-center gap-1">
                <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
                Support available 24/7
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-4 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-slate-400">
          <p>&copy; {currentYear} Elcid Research. All rights reserved.</p>
          <p className="flex items-center gap-1">
            Made with <FaHeart className="text-red-400 animate-pulse" /> for global insights
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
